import { Process } from "shared/types/__generated__/graphql"

export function isProcessFinished(process: Process) {
  return !!process.finished
}
